import { createFileRoute } from "@tanstack/react-router";

import { ProfileSurveys } from "@/components/profiles/profile-surveys";

const ProfileSurveysPage = () => {
  return <ProfileSurveys />;
};

export const Route = createFileRoute("/_private/profiles/$id/surveys/")({
  component: ProfileSurveysPage,
});
